import { Button, Form, Input, Modal, Select, Switch } from 'antd'
import { FormProps, useForm } from 'antd/lib/form/Form'
import React, { useEffect, useState } from 'react'
import useToast from '../../hook/useToast'
import { mixPostV2 } from '../../services/mixin'
interface Props {
  show: boolean
  hideStatus?: boolean
  modalClose?: () => void
  onSubmitted?: () => void
  // onSubmitted?: (values: any) => void // if you want to pass form values
  source?: any
  sourceId?: any
  keyConfiguration?: any
}

type FieldType = {
  status: boolean
  code: string
  name: string
  // system: any[]
}

const CreateSystemParamModal: React.FC<Props> = (props) => {
  const { show, hideStatus = false, modalClose, onSubmitted, source, sourceId, keyConfiguration } = props
  const [visible, setVisible] = useState(show)
  const [form] = useForm()
  const pushToast = useToast()

  useEffect(() => {
    form.setFieldValue('system', sourceId ? [sourceId] : null)
    setVisible(show)
  }, [show])

  useEffect(() => {
    form.setFieldValue('system', sourceId ? [sourceId] : null)
  }, [sourceId])

  // CLOSE MODAL
  const onClose = () => {
    setVisible(false)

    if (modalClose) {
      modalClose()
    }
  }

  // SUBMIT FORM
  const [formLoading, setFormLoading] = useState(false)
  const submitForm: FormProps<FieldType>['onFinish'] = async (values: any) => {
    const listSource = [] as any
    values.system.map((val: any) => {
      listSource.push({
        source_id: val,
      })
      return true
    })
    const params = {
      name: values.name,
      is_active: values.status,
      is_default: 0,
      code: values.code,
      note: values.note,
      list_source_id: JSON.stringify(listSource),
    } as any

    setFormLoading(true)
    const res = await mixPostV2('/api/v1/be/source_column_warehouse', params)
    setFormLoading(false)
    if (res.status) {
      setVisible(false)
      form.resetFields()
      pushToast('Tạo param thành công', 'success')

      if (onSubmitted) {
        onSubmitted()
        // onSubmitted(values) // if you want to pass form values
      }
    } else {
      const er = res.error[Object.keys(res.error)[0]]
      pushToast(er, 'warning')
    }
  }

  return (
    <Modal
      open={visible}
      title='Tạo param hệ thống'
      className='rs-modal w-400 footer-content-end'
      maskClosable={false}
      keyboard={false}
      centered
      footer={() => (
        <>
          <Button
            className="rs-button"
            onClick={onClose}
          >Hủy</Button>
          <Button
            type="primary"
            className="rs-button"
            loading={formLoading}
            onClick={() => { form.submit() }}
          >Tạo</Button>
        </>
      )}
      onCancel={onClose}
      afterOpenChange={() => { form.setFieldValue('status', true) }}
    >
      <Form
        form={form}
        layout='vertical'
        className='rs-form'
        requiredMark={false}
        onFinish={submitForm}
      >
        <Form.Item
          name='code'
          label='Mã'
          rules={[
            {
              required: true,
              message: 'Vui lòng chọn mã'
            }
          ]}
        >
          <Select
            className='rs-select'
            placeholder='Chọn mã'
            showSearch
            allowClear
            filterOption={(input, option) => {
              const normalize = (s: any) =>
                String(s ?? '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
                  .replace(/Đ/g, 'D')
                  .toLowerCase()

              const label = option?.label ?? option?.children ?? option?.value ?? ''
              return normalize(label).includes(normalize(input))
            }}
            options={keyConfiguration ? keyConfiguration.map((val: any) => ({ label: val.value_key, value: val.name_key })) : []}
          />
        </Form.Item>

        <Form.Item
          name='name'
          label='Tên Param'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập Tên Param'
            }
          ]}
        >
          <Input
            className='rs-input rs-input--32'
            placeholder='Tên Param'
          />
        </Form.Item>

        <Form.Item
          name='note'
          label='Ghi chú'
        >
          <Input.TextArea
            className='rs-input rs-input--32'
            placeholder='Ghi chú'
          />
        </Form.Item>
        <Form.Item
          name='system'
          label='Chọn hệ thống'
          rules={[
            {
              required: true,
              message: 'Vui lòng chọn hệ thống'
            }
          ]}
        >
          <Select
            className='rs-select'

            placeholder='Chọn hệ thống'
            mode='multiple'
            options={source ? source.map((val: any) => ({ label: val.name, value: val.id })) : []}
          />
        </Form.Item>
        <Form.Item
          hidden={hideStatus}
          name='status'
          label='Trạng thái'
          valuePropName="checked"
          layout='horizontal'
          className='rs-form-item--horizontal'
        >
          <Switch className='rs-switch' />
        </Form.Item>

        <Form.Item
          hidden={hideStatus}
          name='is_default'
          label='Gợi ý hiển thị'
          valuePropName="checked"
          layout='horizontal'
          className='rs-form-item--horizontal'
        >
          <Switch className='rs-switch' />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateSystemParamModal
